export default (languageCode: string) => /* GraphQL */ `
    mutation SetSelected($listId: ID!) {
        lists: setSelected(listId: $listId, itemPresentation: { languageCode: "${languageCode}" }) {
            listId
            name
        }
    }
`;
